"use strict";
// Copyright © Veeam Software Group GmbH
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberCellRenderer = exports.numberWrapId = exports.NumberWrap = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
exports.NumberWrap = styled_components_1.default.div `
    white-space: nowrap;
    display: block;
    text-align: right;
    width: 100%;
`;
exports.numberWrapId = 'grid-number-wrap';
const numberCellRenderer = ({ cellData }) => (react_1.default.createElement(exports.NumberWrap, { "data-selector-id": exports.numberWrapId }, String(cellData)));
exports.numberCellRenderer = numberCellRenderer;
//# sourceMappingURL=numberCellRenderer.js.map